import React, { forwardRef } from "react";
import { BSHeading } from "../../types";

export const CardSubtitle = forwardRef<HTMLHeadingElement, BSHeading>(
  ({ children, className = "", component: Component = "h6", ...props }, ref) => {
    return (
      <Component {...props} className={`card-subtitle ${className}`} ref={ref}>
        {children}
      </Component>
    );
  }
);